export const DEFAULT_PALETTE = [
  { color: "#3B82F6", name: "Blauw" },
  { color: "#EAB308", name: "Geel" },
  { color: "#EF4444", name: "Rood" },
  { color: "#22C55E", name: "Groen" },
  { color: "#F97316", name: "Oranje" },
  { color: "#A855F7", name: "Paars" },
  { color: "#EC4899", name: "Roze" },
  { color: "#14B8A6", name: "Turquoise" },
  { color: "#64748B", name: "Grijs" },
  { color: "#92400E", name: "Bruin" },
];

export const getPalette = (company) => {
  const p = company?.settings?.color_palette;
  return Array.isArray(p) && p.length ? p : DEFAULT_PALETTE;
};

export const paletteName = (palette, color) =>
  palette.find((p) => p.color.toLowerCase() === (color || "").toLowerCase())?.name || "";

export const toMins = (t) => { const [h, m] = (t || "00:00").split(":").map(Number); return h * 60 + m; };
export const fmtMins = (mins) => `${String(Math.floor(mins / 60)).padStart(2, "0")}:${String(mins % 60).padStart(2, "0")}`;

// Vrij dagdeel: alleen ochtend gepland → middag vrij; alleen middag → ochtend vrij.
export function freeSlot(items, dayStart, dayEnd) {
  if (!items.length) return null;
  const MID = 12 * 60 + 30;
  const latestEnd = Math.max(...items.map((a) => toMins(a.end_time)));
  const earliestStart = Math.min(...items.map((a) => toMins(a.start_time)));
  const end = toMins(dayEnd);
  const start = toMins(dayStart);
  if (latestEnd <= MID && end - latestEnd >= 60) return { pos: "after", label: "Middag vrij", start: fmtMins(latestEnd), end: dayEnd };
  if (earliestStart >= 12 * 60 && earliestStart - start >= 60) return { pos: "before", label: "Ochtend vrij", start: dayStart, end: fmtMins(earliestStart) };
  return null;
}
